module.exports = __webpack_public_path__ + "static/media/melissa9.315dff00.jpg";